export { ThirdType } from "./third-type";
